module.exports = __webpack_public_path__ + "img/temper_green.c79e8bd5.svg";